module.exports = __webpack_public_path__ + "img/email.2177ad56.svg";